import './styles.scss';
import React from 'react';
import ListFilters from './ListFilters';

const AlgoliaHeader: React.FC<{ listId: string }> = React.memo(({ listId }) => {
  return (
    <>
      <ListFilters listId={listId} />
    </>
  );
});

export default AlgoliaHeader;
